var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "gantt-chart-container" },
    [
      _vm.$truckLoading
        ? [_c("div", { staticClass: "loader-round" })]
        : _c(
            "div",
            { staticClass: "scroll-bar-wrap", style: _vm.gcContainerStyle },
            [
              _vm.filteredTrucks.length >= 1
                ? _c(
                    "div",
                    {
                      ref: "ganttChart",
                      staticClass: "gantt-chart scroll-box",
                      attrs: { id: "ganttChart" },
                    },
                    [
                      _c(
                        "el-row",
                        {
                          staticClass: "gantt-chart-header",
                          style: _vm.gcHeaderStyle,
                          attrs: { type: "flex" },
                        },
                        [
                          _c("el-col", {
                            staticClass: "left",
                            style: {
                              width: _vm.$isMobile
                                ? _vm.smallLeftWidth + "px"
                                : _vm.leftWidth + "px",
                            },
                          }),
                          _c(
                            "el-col",
                            { staticClass: "right" },
                            _vm._l(_vm.timeList, function (date, dateIndex) {
                              return _c(
                                "div",
                                {
                                  key: dateIndex,
                                  staticClass: "time-list-container",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "time-list-date",
                                      style: {
                                        left:
                                          _vm.ganttChartCellWidth *
                                            date.timeList[0].counter -
                                          20 +
                                          "px",
                                      },
                                    },
                                    [_vm._v(" " + _vm._s(date.date) + " ")]
                                  ),
                                  _vm._l(
                                    date.timeList,
                                    function (time, timeIndex) {
                                      return _c(
                                        "div",
                                        {
                                          key: timeIndex,
                                          staticClass: "time-list",
                                          style: {
                                            left:
                                              _vm.ganttChartCellWidth *
                                                time.counter +
                                              "px",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                position: "absolute",
                                                left: "-20px",
                                              },
                                            },
                                            [_vm._v(_vm._s(time.time))]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              )
                            }),
                            0
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        {
                          staticClass: "vertical-lines-header",
                          style: _vm.gcHeaderStyle,
                          attrs: { type: "flex" },
                        },
                        [
                          _c("el-col", { staticClass: "left" }),
                          _c(
                            "el-col",
                            {
                              staticClass: "right",
                              style: {
                                "margin-left": _vm.$isMobile
                                  ? _vm.smallLeftWidth + "px"
                                  : _vm.leftWidth + "px",
                              },
                            },
                            _vm._l(_vm.timeList, function (date, dateIndex) {
                              return _c(
                                "div",
                                {
                                  key: "t" + dateIndex,
                                  staticClass: "vertical-lines-container",
                                },
                                _vm._l(
                                  date.timeList,
                                  function (time, timeIndex) {
                                    return dateIndex !== 0 || timeIndex !== 0
                                      ? _c("div", {
                                          key: "t" + timeIndex,
                                          staticClass: "vertical-lines",
                                          style: {
                                            left:
                                              _vm.ganttChartCellWidth *
                                                time.counter +
                                              "px",
                                            height:
                                              _vm.filteredTrucks.length * 31 +
                                              "px",
                                          },
                                        })
                                      : _vm._e()
                                  }
                                ),
                                0
                              )
                            }),
                            0
                          ),
                        ],
                        1
                      ),
                      _vm._l(_vm.filteredTrucks, function (truck, truckIndex) {
                        return _c(
                          "el-row",
                          {
                            key: truckIndex,
                            staticClass: "truck no-gutters",
                            class: _vm.getGCRowClass(truck, truckIndex),
                            style: _vm.getGCRowStyle(truck, truckIndex),
                            attrs: { type: "flex" },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.setTruck(truck.id)
                              },
                            },
                          },
                          [
                            _c(
                              "el-col",
                              {
                                staticClass: "truck-header",
                                style: {
                                  width: _vm.$isMobile
                                    ? _vm.smallLeftWidth + "px"
                                    : _vm.leftWidth + "px",
                                },
                              },
                              [
                                _vm.isShowCheckmark(truck)
                                  ? _c(
                                      "div",
                                      { staticClass: "d-none d-md-block" },
                                      [
                                        _vm.checkDisable(truck.id)
                                          ? _c("font-awesome-icon", {
                                              staticClass: "truck-disable",
                                              staticStyle: { margin: "4px" },
                                              attrs: { icon: "ban" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.enableTruck(
                                                    truck.id
                                                  )
                                                },
                                              },
                                            })
                                          : _c("font-awesome-icon", {
                                              staticClass: "truck-enable",
                                              staticStyle: { margin: "4px" },
                                              attrs: { icon: "check-circle" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.disableTruck(
                                                    truck.id
                                                  )
                                                },
                                              },
                                            }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.hasRouteDetails(truck.id)
                                  ? _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "d-none d-md-block",
                                        attrs: { placement: "left" },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.tooltip.estimatedDistance"
                                                    )
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.helper.printThousandDecimal(
                                                      _vm.getRouteDetails(
                                                        truck.id
                                                      )["estimatedDistance"]
                                                    )
                                                  ) +
                                                  " m "
                                              ),
                                            ]),
                                            _c("br"),
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.tooltip.estimatedTravellingTime"
                                                    )
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.helper.secondsToHms(
                                                      _vm.getRouteDetails(
                                                        truck.id
                                                      )[
                                                        "estimatedTravellingTime"
                                                      ]
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c("font-awesome-icon", {
                                          staticClass: "truck-route",
                                          attrs: { icon: "sign" },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.isDashboard && _vm.hasData(truck.id)
                                  ? _c("font-awesome-icon", {
                                      staticClass: "truck-circle",
                                      attrs: { icon: "circle" },
                                    })
                                  : _vm._e(),
                                _c(
                                  "el-tooltip",
                                  { attrs: { placement: "left" } },
                                  [
                                    _c(
                                      "div",
                                      {
                                        attrs: { slot: "content" },
                                        slot: "content",
                                      },
                                      [
                                        _vm._v(" " + _vm._s(truckIndex + 1)),
                                        _c("br"),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("general.usedBy")) +
                                            ": " +
                                            _vm._s(
                                              _vm.getGlobalTruckInfo(
                                                truck.id,
                                                "userName"
                                              )
                                            )
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "planning.columns.plateNumber"
                                              )
                                            ) +
                                            ": " +
                                            _vm._s(truck.plateNumber || "-")
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "planning.columns.vehicleType"
                                              )
                                            ) +
                                            ": " +
                                            _vm._s(truck.vehicleType || "-")
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "planning.columns.truckType"
                                              )
                                            ) +
                                            ": " +
                                            _vm._s(
                                              truck.truckType
                                                ? "" + truck.truckType
                                                : "-"
                                            )
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "planning.columns.brandName"
                                              )
                                            ) +
                                            ": " +
                                            _vm._s(
                                              truck.brandName
                                                ? "" + truck.brandName
                                                : "-"
                                            )
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "planning.columns.weightCapacity"
                                              )
                                            ) +
                                            ": " +
                                            _vm._s(
                                              truck.weight
                                                ? "" +
                                                    _vm.helper.printThousandDecimal(
                                                      truck.weight
                                                    )
                                                : 0
                                            )
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "planning.columns.volumeCapacity"
                                              )
                                            ) +
                                            ": " +
                                            _vm._s(
                                              truck.volume
                                                ? "" +
                                                    _vm.helper.printThousandDecimal(
                                                      parseFloat(truck.volume)
                                                    )
                                                : 0
                                            )
                                        ),
                                        _c("br"),
                                      ]
                                    ),
                                    _c("font-awesome-icon", {
                                      style: {
                                        "margin-left": _vm.isAutoAssign
                                          ? "20px"
                                          : 0,
                                      },
                                      attrs: { icon: "info-circle" },
                                    }),
                                  ],
                                  1
                                ),
                                _c("span", { staticClass: "title ml-1" }, [
                                  _vm._v(_vm._s(truck.plateNumber)),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              {
                                staticClass: "truck-timetable",
                                style: {
                                  width: _vm.$isMobile
                                    ? "calc(100% - " +
                                      _vm.smallLeftWidth +
                                      "px)"
                                    : "calc(100% - " + _vm.leftWidth + "px)",
                                },
                              },
                              [
                                _vm.isTodayInRange
                                  ? _c("div", {
                                      staticClass: "current-time",
                                      style: {
                                        left: _vm.currentTimeLeft + "px",
                                      },
                                    })
                                  : _vm._e(),
                                _c(
                                  "div",
                                  { staticClass: "content" },
                                  [
                                    _vm._l(
                                      _vm.getRoutes(truck.id),
                                      function (route, routeIndex) {
                                        return _c(
                                          "el-tooltip",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.routeViewOptions.includes(
                                                    "plannedRoutes"
                                                  ),
                                                expression:
                                                  "routeViewOptions.includes('plannedRoutes')",
                                              },
                                            ],
                                            key:
                                              "r-" +
                                              route.masterpointId +
                                              "-" +
                                              routeIndex,
                                            style: _vm.getContainerStyles(
                                              route,
                                              "plannedRoutes"
                                            ),
                                            attrs: { placement: "top" },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content",
                                              },
                                              [
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.plannedR"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      "#" +
                                                        _vm._s(routeIndex + 1) +
                                                        " - " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "planning.waypointType." +
                                                              route.waypointType
                                                          )
                                                        )
                                                    ),
                                                  ]),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.columns.status"
                                                        )
                                                      ) + ": "
                                                    ),
                                                  ]),
                                                  _vm._v(_vm._s(route.status)),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.columns.zone"
                                                        )
                                                      ) + ": "
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    _vm._s(
                                                      route.zone === ""
                                                        ? "-"
                                                        : route.zone
                                                    )
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.columns.locationCode"
                                                        )
                                                      ) + ": "
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        route.additionalData &&
                                                          route.additionalData
                                                            .seekCode === ""
                                                          ? "-"
                                                          : route.additionalData
                                                              .seekCode
                                                      ) +
                                                      " "
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _vm._v(
                                                    _vm._s(route.displayAddress)
                                                  ),
                                                ]),
                                                _c("hr"),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.startTravelling"
                                                        )
                                                      ) + ": "
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("convertTimezone")(
                                                        route.startTime,
                                                        _vm.$timezone
                                                      )
                                                    )
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.travellingTime"
                                                        )
                                                      ) + ": "
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.helper.printThousandDecimal(
                                                        route.time / 60
                                                      )
                                                    ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.minutes"
                                                        )
                                                      )
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.start"
                                                        )
                                                      ) + ": "
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("convertTimezone")(
                                                        route.estimateTime,
                                                        _vm.$timezone
                                                      )
                                                    )
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.handlingTime"
                                                        )
                                                      ) + ": "
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.helper.printThousandDecimal(
                                                        route.handlingTime / 60
                                                      )
                                                    ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.minutes"
                                                        )
                                                      )
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.end"
                                                        )
                                                      ) + ": "
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("convertTimezone")(
                                                        route.endTime,
                                                        _vm.$timezone
                                                      )
                                                    )
                                                  ),
                                                ]),
                                                _c("hr"),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.columns.planId"
                                                        )
                                                      ) + ": "
                                                    ),
                                                  ]),
                                                  _vm._v(_vm._s(route.planId)),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.columns.projectCode"
                                                        )
                                                      ) + ": "
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    _vm._s(
                                                      route.projectCode
                                                        ? route.projectCode.join(
                                                            ", "
                                                          )
                                                        : ""
                                                    )
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.shipRefs"
                                                        )
                                                      ) + ": "
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    _vm._s(
                                                      route.shipmentReference
                                                        ? route.shipmentReference.join(
                                                            ", "
                                                          )
                                                        : ""
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            route &&
                                            _vm.isDateInRange(
                                              route,
                                              "plannedRoutes"
                                            )
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "cursor-pointer position-absolute",
                                                  },
                                                  [
                                                    _c("div", {
                                                      staticClass:
                                                        "travelling-time",
                                                      style: _vm.getRouteStyles(
                                                        route,
                                                        "travellingTime",
                                                        "plannedRoutes"
                                                      ),
                                                    }),
                                                    _c("div", {
                                                      staticClass:
                                                        "handling-time",
                                                      class:
                                                        _vm.getStatusColor(
                                                          route
                                                        ),
                                                      style: _vm.getRouteStyles(
                                                        route,
                                                        "handlingTime",
                                                        "plannedRoutes"
                                                      ),
                                                    }),
                                                    !_vm.isDashboard
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "route-index",
                                                            style:
                                                              _vm.getIndexStyles(),
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                routeIndex + 1
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm.isDashboard &&
                                                    route.additionalData
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "route-index",
                                                            style:
                                                              _vm.getIndexStyles(),
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  route
                                                                    .additionalData
                                                                    .seekCode ===
                                                                    ""
                                                                    ? ""
                                                                    : route
                                                                        .additionalData
                                                                        .seekCode
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _c("span", {
                                                      class:
                                                        _vm.getRouteSeparatorClass(
                                                          _vm.getRoutes(
                                                            truck.id
                                                          ),
                                                          route
                                                        ),
                                                      style:
                                                        _vm.getRouteSeparatorStyle(),
                                                    }),
                                                    _vm.isRouteFirstPlan(
                                                      _vm.getRoutes(truck.id),
                                                      route
                                                    )
                                                      ? _c(
                                                          "span",
                                                          {
                                                            class:
                                                              _vm.getCycleNumberClass(
                                                                _vm.getRoutes(
                                                                  truck.id
                                                                ),
                                                                route
                                                              ),
                                                            style:
                                                              _vm.getCycleNumberStyle(),
                                                          },
                                                          [
                                                            route.additionalData
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "cycle-number",
                                                                    style: {
                                                                      "font-size":
                                                                        _vm
                                                                          .routeViewOptions
                                                                          .length ===
                                                                        2
                                                                          ? "12px"
                                                                          : "1rem",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          route
                                                                            .additionalData
                                                                            .cycle ===
                                                                            ""
                                                                            ? ""
                                                                            : route
                                                                                .additionalData
                                                                                .cycle
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        )
                                      }
                                    ),
                                    _vm._l(
                                      _vm.getRoutes(truck.id),
                                      function (route, routeIndex) {
                                        return _c(
                                          "el-tooltip",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.routeViewOptions.includes(
                                                    "suggestedRoutes"
                                                  ),
                                                expression:
                                                  "routeViewOptions.includes('suggestedRoutes')",
                                              },
                                            ],
                                            key:
                                              "sr-" +
                                              route.masterpointId +
                                              "-" +
                                              routeIndex,
                                            style: _vm.getContainerStyles(
                                              route,
                                              "suggestedRoutes"
                                            ),
                                            attrs: { placement: "bottom" },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content",
                                              },
                                              [
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.suggestedRoutes"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      "#" +
                                                        _vm._s(routeIndex + 1) +
                                                        " - " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "planning.waypointType." +
                                                              route.waypointType
                                                          )
                                                        )
                                                    ),
                                                  ]),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.columns.zone"
                                                        )
                                                      ) + ": "
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    _vm._s(
                                                      route.zone === ""
                                                        ? "-"
                                                        : route.zone
                                                    )
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.columns.locationCode"
                                                        )
                                                      ) + ": "
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        route.additionalData &&
                                                          route.additionalData
                                                            .seekCode === ""
                                                          ? "-"
                                                          : route.additionalData
                                                              .seekCode
                                                      ) +
                                                      " "
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _vm._v(
                                                    _vm._s(route.displayAddress)
                                                  ),
                                                ]),
                                                _c("hr"),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.startTravelling"
                                                        )
                                                      ) + ": "
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("convertTimezone")(
                                                        route.suggestedData
                                                          .startTime,
                                                        _vm.$timezone
                                                      )
                                                    )
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.travellingTime"
                                                        )
                                                      ) + ": "
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.helper.printThousandDecimal(
                                                        route.suggestedData
                                                          .time / 60
                                                      )
                                                    ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.minutes"
                                                        )
                                                      )
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.start"
                                                        )
                                                      ) + ": "
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("convertTimezone")(
                                                        route.suggestedData
                                                          .estimateTime,
                                                        _vm.$timezone
                                                      )
                                                    )
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.handlingTime"
                                                        )
                                                      ) + ": "
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.helper.printThousandDecimal(
                                                        route.suggestedData
                                                          .handlingTime / 60
                                                      )
                                                    ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.minutes"
                                                        )
                                                      )
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.end"
                                                        )
                                                      ) + ": "
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("convertTimezone")(
                                                        route.suggestedData
                                                          .endTime,
                                                        _vm.$timezone
                                                      )
                                                    )
                                                  ),
                                                ]),
                                                _c("hr"),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.columns.planId"
                                                        )
                                                      ) + ": "
                                                    ),
                                                  ]),
                                                  _vm._v(_vm._s(route.planId)),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.columns.projectCode"
                                                        )
                                                      ) + ": "
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    _vm._s(
                                                      route.projectCode
                                                        ? route.projectCode.join(
                                                            ", "
                                                          )
                                                        : ""
                                                    )
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.shipRefs"
                                                        )
                                                      ) + ": "
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    _vm._s(
                                                      route.shipmentReference
                                                        ? route.shipmentReference.join(
                                                            ", "
                                                          )
                                                        : ""
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            route.suggestedData &&
                                            _vm.isDateInRange(
                                              route,
                                              "suggestedRoutes"
                                            )
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "cursor-pointer position-absolute",
                                                  },
                                                  [
                                                    _c("div", {
                                                      staticClass:
                                                        "s-travelling-time",
                                                      style: _vm.getRouteStyles(
                                                        route,
                                                        "suggestedTravellingTime",
                                                        "suggestedRoutes"
                                                      ),
                                                    }),
                                                    _c("div", {
                                                      staticClass:
                                                        "s-handling-time",
                                                      class:
                                                        _vm.getStatusColor(
                                                          route
                                                        ),
                                                      style: _vm.getRouteStyles(
                                                        route,
                                                        "suggestedHandlingTime",
                                                        "suggestedRoutes"
                                                      ),
                                                    }),
                                                    !_vm.isDashboard
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "route-index",
                                                            style:
                                                              _vm.getIndexStyles(),
                                                          },
                                                          [
                                                            _vm._v(
                                                              "S" +
                                                                _vm._s(
                                                                  routeIndex + 1
                                                                )
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _c("span", {
                                                      class:
                                                        _vm.getRouteSeparatorClass(
                                                          _vm.getRoutes(
                                                            truck.id
                                                          ),
                                                          route
                                                        ),
                                                      style:
                                                        _vm.getRouteSeparatorStyle(),
                                                    }),
                                                    _vm.isRouteFirstPlan(
                                                      _vm.getRoutes(truck.id),
                                                      route
                                                    )
                                                      ? _c(
                                                          "span",
                                                          {
                                                            class:
                                                              _vm.getCycleNumberClass(
                                                                _vm.getRoutes(
                                                                  truck.id
                                                                ),
                                                                route
                                                              ),
                                                            style:
                                                              _vm.getCycleNumberStyle(),
                                                          },
                                                          [
                                                            route.additionalData
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "cycle-number",
                                                                    style: {
                                                                      "font-size":
                                                                        _vm
                                                                          .routeViewOptions
                                                                          .length ===
                                                                        2
                                                                          ? "12px"
                                                                          : "1rem",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          route
                                                                            .additionalData
                                                                            .cycle ===
                                                                            ""
                                                                            ? ""
                                                                            : route
                                                                                .additionalData
                                                                                .cycle
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        )
                                      }
                                    ),
                                    _vm._l(
                                      _vm.getRoutes(truck.id),
                                      function (route, routeIndex) {
                                        return _c(
                                          "el-tooltip",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.routeViewOptions.includes(
                                                    "actualRoutes"
                                                  ),
                                                expression:
                                                  "routeViewOptions.includes('actualRoutes')",
                                              },
                                            ],
                                            key:
                                              "ar-" +
                                              route.masterpointId +
                                              "-" +
                                              routeIndex,
                                            style: _vm.getContainerStyles(
                                              route,
                                              "actualRoutes"
                                            ),
                                            attrs: { placement: "bottom" },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content",
                                              },
                                              [
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.actualRoutes"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      "#" +
                                                        _vm._s(routeIndex + 1) +
                                                        " - " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "planning.waypointType." +
                                                              route.waypointType
                                                          )
                                                        )
                                                    ),
                                                  ]),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.columns.zone"
                                                        )
                                                      ) + ": "
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    _vm._s(
                                                      route.zone === ""
                                                        ? "-"
                                                        : route.zone
                                                    )
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.columns.locationCode"
                                                        )
                                                      ) + ": "
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        route.additionalData &&
                                                          route.additionalData
                                                            .seekCode === ""
                                                          ? "-"
                                                          : route.additionalData
                                                              .seekCode
                                                      ) +
                                                      " "
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _vm._v(
                                                    _vm._s(route.displayAddress)
                                                  ),
                                                ]),
                                                _c("hr"),
                                                route.waypointType === "T"
                                                  ? [
                                                      _c("div", [
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "planning.tooltip.startTravelling"
                                                              )
                                                            ) + ": "
                                                          ),
                                                        ]),
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "convertTimezone"
                                                            )(
                                                              route.startTime,
                                                              _vm.$timezone
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                      _c("div", [
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "planning.tooltip.travellingTime"
                                                              )
                                                            ) + ": "
                                                          ),
                                                        ]),
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.helper.printThousandDecimal(
                                                              route.time / 60
                                                            )
                                                          ) +
                                                            " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "planning.tooltip.minutes"
                                                              )
                                                            )
                                                        ),
                                                      ]),
                                                      _c("div", [
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "planning.tooltip.start"
                                                              )
                                                            ) + ": "
                                                          ),
                                                        ]),
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "convertTimezone"
                                                            )(
                                                              route.estimateTime,
                                                              _vm.$timezone
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                      _c("div", [
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "planning.tooltip.handlingTime"
                                                              )
                                                            ) + ": "
                                                          ),
                                                        ]),
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.helper.printThousandDecimal(
                                                              route.handlingTime /
                                                                60
                                                            )
                                                          ) +
                                                            " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "planning.tooltip.minutes"
                                                              )
                                                            )
                                                        ),
                                                      ]),
                                                      _c("div", [
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "planning.tooltip.end"
                                                              )
                                                            ) + ": "
                                                          ),
                                                        ]),
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "convertTimezone"
                                                            )(
                                                              route.endTime,
                                                              _vm.$timezone
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  : [
                                                      _c("div", [
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "planning.tooltip.startTravelling"
                                                              )
                                                            ) + ": "
                                                          ),
                                                        ]),
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "convertTimezone"
                                                            )(
                                                              route.actualData
                                                                .startTime,
                                                              _vm.$timezone
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                      _c("div", [
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "planning.tooltip.travellingTime"
                                                              )
                                                            ) + ": "
                                                          ),
                                                        ]),
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.helper.printThousandDecimal(
                                                              route.actualData
                                                                .time / 60
                                                            )
                                                          ) +
                                                            " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "planning.tooltip.minutes"
                                                              )
                                                            )
                                                        ),
                                                      ]),
                                                      _c("div", [
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "planning.tooltip.start"
                                                              )
                                                            ) + ": "
                                                          ),
                                                        ]),
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "convertTimezone"
                                                            )(
                                                              route.actualData
                                                                .estimateTime,
                                                              _vm.$timezone
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                      _c("div", [
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "planning.tooltip.handlingTime"
                                                              )
                                                            ) + ": "
                                                          ),
                                                        ]),
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.helper.printThousandDecimal(
                                                              route.actualData
                                                                .handlingTime /
                                                                60
                                                            )
                                                          ) +
                                                            " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "planning.tooltip.minutes"
                                                              )
                                                            )
                                                        ),
                                                      ]),
                                                      _c("div", [
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "planning.tooltip.end"
                                                              )
                                                            ) + ": "
                                                          ),
                                                        ]),
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "convertTimezone"
                                                            )(
                                                              route.actualData
                                                                .endTime,
                                                              _vm.$timezone
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ],
                                                _c("hr"),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.columns.planId"
                                                        )
                                                      ) + ": "
                                                    ),
                                                  ]),
                                                  _vm._v(_vm._s(route.planId)),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.columns.projectCode"
                                                        )
                                                      ) + ": "
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    _vm._s(
                                                      route.projectCode
                                                        ? route.projectCode.join(
                                                            ", "
                                                          )
                                                        : ""
                                                    )
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.shipRefs"
                                                        )
                                                      ) + ": "
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    _vm._s(
                                                      route.shipmentReference
                                                        ? route.shipmentReference.join(
                                                            ", "
                                                          )
                                                        : ""
                                                    )
                                                  ),
                                                ]),
                                                route.waypointType !== "T"
                                                  ? [
                                                      _c("hr"),
                                                      _c("div", [
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "planning.isETAEarlyLate"
                                                              )
                                                            ) + ": "
                                                          ),
                                                        ]),
                                                        _vm._v(
                                                          _vm._s(
                                                            !route.actualData
                                                              .estimateOnTime
                                                          )
                                                        ),
                                                      ]),
                                                      _c("div", [
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "planning.etaDiscrepancy"
                                                              )
                                                            ) + ": "
                                                          ),
                                                        ]),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "general." +
                                                                  route
                                                                    .actualData
                                                                    .estimateInfo
                                                              )
                                                            ) +
                                                            " " +
                                                            _vm._s(
                                                              _vm.helper.secondsToHms(
                                                                route.actualData
                                                                  .runningTimeDifference
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]),
                                                      _c("br"),
                                                      _c("div", [
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "planning.isEndTimeEarlyLate"
                                                              )
                                                            ) + ": "
                                                          ),
                                                        ]),
                                                        _vm._v(
                                                          _vm._s(
                                                            !route.actualData
                                                              .endOnTime
                                                          )
                                                        ),
                                                      ]),
                                                      _c("div", [
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "planning.endTimeDiscrepancy"
                                                              )
                                                            ) + ": "
                                                          ),
                                                        ]),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "general." +
                                                                  route
                                                                    .actualData
                                                                    .endInfo
                                                              )
                                                            ) +
                                                            " " +
                                                            _vm._s(
                                                              _vm.helper.secondsToHms(
                                                                route.actualData
                                                                  .endRunningTimeDifference
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]),
                                                    ]
                                                  : _vm._e(),
                                              ],
                                              2
                                            ),
                                            route.actualData &&
                                            _vm.isDateInRange(
                                              route,
                                              "actualRoutes"
                                            )
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "cursor-pointer position-absolute",
                                                  },
                                                  [
                                                    _c("div", {
                                                      staticClass:
                                                        "a-travelling-time",
                                                      class:
                                                        _vm.getActualRouteClass(
                                                          route
                                                        ),
                                                      style: _vm.getRouteStyles(
                                                        route,
                                                        "actualTravellingTime",
                                                        "actualRoutes"
                                                      ),
                                                    }),
                                                    _c("div", {
                                                      staticClass:
                                                        "a-handling-time",
                                                      class:
                                                        _vm.getActualRouteClass(
                                                          route
                                                        ),
                                                      style: _vm.getRouteStyles(
                                                        route,
                                                        "actualHandlingTime",
                                                        "actualRoutes"
                                                      ),
                                                    }),
                                                    !_vm.isDashboard
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "route-index",
                                                            style:
                                                              _vm.getIndexStyles(),
                                                          },
                                                          [
                                                            _vm._v(
                                                              "A" +
                                                                _vm._s(
                                                                  routeIndex + 1
                                                                )
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _c("span", {
                                                      class:
                                                        _vm.getRouteSeparatorClass(
                                                          _vm.getRoutes(
                                                            truck.id
                                                          ),
                                                          route
                                                        ),
                                                      style:
                                                        _vm.getRouteSeparatorStyle(),
                                                    }),
                                                    _vm.isRouteFirstPlan(
                                                      _vm.getRoutes(truck.id),
                                                      route
                                                    )
                                                      ? _c(
                                                          "span",
                                                          {
                                                            class:
                                                              _vm.getCycleNumberClass(
                                                                _vm.getRoutes(
                                                                  truck.id
                                                                ),
                                                                route
                                                              ),
                                                            style:
                                                              _vm.getCycleNumberStyle(),
                                                          },
                                                          [
                                                            route.additionalData
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "cycle-number",
                                                                    style: {
                                                                      "font-size":
                                                                        _vm
                                                                          .routeViewOptions
                                                                          .length ===
                                                                        2
                                                                          ? "12px"
                                                                          : "1rem",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          route
                                                                            .additionalData
                                                                            .cycle ===
                                                                            ""
                                                                            ? ""
                                                                            : route
                                                                                .additionalData
                                                                                .cycle
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      }),
                      _vm.filteredTrucks < _vm.$trucks
                        ? _c(
                            "div",
                            {
                              staticClass: "truck-header text-center",
                              style: {
                                width: _vm.$isMobile
                                  ? _vm.smallLeftWidth + "px"
                                  : _vm.leftWidth + "px",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", size: "mini" },
                                  on: { click: _vm.appendMoreTruck },
                                },
                                [_vm._v(_vm._s(_vm.$t("general.showMore")))]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
              _c("div", { staticClass: "v-cover-bar" }),
              _c("div", { staticClass: "h-cover-bar" }),
              _vm.filteredTrucks.length === 0
                ? _c("div", [
                    _c("p", { staticClass: "no-vehicle" }, [
                      _vm._v(_vm._s(_vm.$t("truck.noVehicle"))),
                    ]),
                  ])
                : _vm._e(),
            ]
          ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }